export default "__VITE_ASSET__CxJcc5BP__"